// extracted by mini-css-extract-plugin
export var header = "_ut-1";
export var maskBottom = "_ut-6";
export var maskMiddle = "_ut-7";
export var maskTop = "_ut-5";
export var root = "_ut-0";
export var scrollDownButton = "_ut-3";
export var scrollDownButtonHidden = "_ut-4";
export var viewport = "_ut-2";